module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stickyParent"
  }, [_c('div', {
    staticClass: "stickyBox static"
  }), _vm._v(" "), _c('div', {
    staticClass: "sticky",
    style: ({
      'top': _vm.top + 'px'
    })
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18e35884"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sticky/sticky.vue
// module id = 231
// module chunks = 28